module.exports = __webpack_public_path__ + "static/media/wipro.3b0d0d3b.jpg";